module.exports = __webpack_public_path__ + "static/media/cliff2.f20b1dbe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/cliff2.jpeg
// module id = 193
// module chunks = 0